import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import Header from './components/Header';
import Background from './components/Background';
import Footer from './components/Footer';
import Research from './components/Research';
import MeetThePI from './components/MeetThePI';
import Publications from './components/Publications';
import Team from './components/Team';
import Media from './components/Media';
import Resources from './components/Resources';
import JoinOurTeam from './components/JoinOurTeam';
import Contact from './components/Contact';
import Support from './components/Support';
import Keywords from './components/Keywords';
import PageNotFound from './components/PageNotFound';
import './App.css';

function App() {
    const location = useLocation();
    const visitedPage = useRef([]);

    useEffect(() => {
        const pageName = location.pathname.replace(/\//, '');
        if (pageName !== '' && !visitedPage.current.includes(pageName)) {
            fetch(`/views/?page=${pageName}`)
                .then(resp => {
                    if (resp.ok) {
                        visitedPage.current.push(pageName);
                    }
                });
        }
    }, [location]);

    return (
        <>
            <div className="body-wrapper">
                <div className="body-width-limited">
                    <Header />
                    <Background />
                    <main className="contents">
                        <Routes>
                            <Route path="/*" element={<PageNotFound />} />
                            <Route path="/research" element={<Research />} />
                            <Route path="/meet-the-pi" element={<MeetThePI />} />
                            <Route path="/publications" element={<Publications />} />
                            <Route path="/team" element={<Team />} />
                            <Route path="/media" element={<Media />} />
                            <Route path="/resources" element={<Resources />} />
                            <Route path="/join-our-team" element={<JoinOurTeam />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/support" element={<Support />} />
                        </Routes>
                        <Footer />
                    </main>
                </div>
            </div>
            <Keywords />
        </>
    );
}

export default App;
